export default __webpack_public_path__ + "static/media/transfer-member-button.b8bdef29.svg";